import EventTarget	from "eventtarget";

class Module extends EventTarget {
  constructor(...args) {    
    super(...args);

    this.id = "webcam";
    this.usbProductName = "webcam";
    this.usbSerialNumber = "1";
    this.name = "webcam";    
    this.status = "Ok";    
  }
  async initialize() {
    this.id = "webcam";
    this.usbProductName = "webcam";
    this.usbSerialNumber = "1";
    this.name = "webcam";    
    this.status = "Ok";    
  }
  async update() {
  } 
  toJSON() {
    return({
      name: this.name,      
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,      
      id: this.id
    });
  }
}

export default Module;